/**
 * @fileoverview The canonical backend base URL.
 *
 * Hans serves a single web domain (kalver.ai), so there is one API base and
 * every client instance imports it from here. This module used to pick a
 * per-hostname API during the lab401.ai → kalver.ai transition, because
 * session cookies are host-only SameSite=None cookies on the API host and a
 * page on one registrable domain calling the other's API would be cross-site.
 * With the second domain retired that selection is gone, but the single
 * import point stays: it is what keeps the four axios instances
 * (api/studentApi/orgApi/opsApi) and the three public pages agreeing on one
 * origin.
 */

const BACKEND_URL = import.meta.env.REACT_APP_BACKEND_URL;

export default BACKEND_URL;
